"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDrillIntersectionAttributeItem = exports.isDrillableItem = exports.isDrillableItemIdentifier = exports.isDrillableItemUri = exports.isExplicitDrill = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var HeaderPredicate_1 = require("../headerMatching/HeaderPredicate");
/**
 * @public
 */
function isExplicitDrill(obj) {
    return [isDrillableItem, HeaderPredicate_1.isHeaderPredicate].some(function (pred) { return pred(obj); });
}
exports.isExplicitDrill = isExplicitDrill;
/**
 * @public
 */
function isDrillableItemUri(item) {
    return !isEmpty_1.default(item) && item.uri !== undefined;
}
exports.isDrillableItemUri = isDrillableItemUri;
/**
 * @public
 */
function isDrillableItemIdentifier(item) {
    return !isEmpty_1.default(item) && item.identifier !== undefined;
}
exports.isDrillableItemIdentifier = isDrillableItemIdentifier;
/**
 * @public
 */
function isDrillableItem(item) {
    return [isDrillableItemUri, isDrillableItemIdentifier].some(function (pred) { return pred(item); });
}
exports.isDrillableItem = isDrillableItem;
/**
 * @public
 */
function isDrillIntersectionAttributeItem(header) {
    return !isEmpty_1.default(header) && header.attributeHeaderItem !== undefined;
}
exports.isDrillIntersectionAttributeItem = isDrillIntersectionAttributeItem;
//# sourceMappingURL=DrillEvents.js.map